import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import ProjectCard from '../components/ProjectCard';
import { db } from '../supabase/supabase';

const Lab = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const data = await db.projects.getAll();
        setProjects(data);
      } catch (err) {
        console.error("DB Fetch Error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  return (
    <div className="space-y-12">
      <div className="max-w-2xl">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 flex items-center gap-3">
          <SafeIcon icon={FiIcons.FiCpu} className="text-emerald-400" /> The Lab
        </h1>
        <p className="text-xl text-slate-400">
          Independent SaaS applications and AI experiments focused on digital inclusion and accessibility.
        </p>
      </div>

      {loading ? (
        <div className="flex justify-center py-20">
          <SafeIcon icon={FiIcons.FiLoader} className="text-4xl text-emerald-500 animate-spin" />
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project, index) => (
            <motion.div
              key={project.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <ProjectCard project={{
                ...project,
                image: project.image_url,
                tags: project.tags || []
              }} />
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Lab;